/**
 * ВАЛЮТА:
 * 0 - русское обозначение
 * 1 - международное обозначение
 */
export const CURRENCY = {
    rub: ['руб.', 'RUB'],
    euro: ['евро.', 'EUR'],
    dollar: ['доллар.', 'USD']
}